import { Form } from 'antd';

import { validateRingRangeRule } from 'technical/validation/rules';
import NumberRangeInput from 'ui/form/number-range-input';

export const NumberRangeInputWithMessage = ({
  name,
  label,
  leftPlaceholder,
  rightPlaceholder,
  message,
}: {
  name: string;
  label?: string;
  leftPlaceholder: string;
  rightPlaceholder: string;
  message?: string;
}) => {
  return (
    <Form.Item
      name={name}
      layout="vertical"
      label={label}
      validateTrigger="onChange"
      rules={[validateRingRangeRule]}
    >
      <NumberRangeInput
        leftInputProps={{
          placeholder: leftPlaceholder,
        }}
        rightInputProps={{
          placeholder: rightPlaceholder,
        }}
        allowClear
        bottomMessage={message}
      />
    </Form.Item>
  );
};
